import { useEffect, useState } from "react";

// ---------------------- Hook

export const useWindowResizing = () => {
  // --------- Variables / Hooks

  const [isResizing, setIsResizing] = useState(false);

  // --------- Effects

  useEffect(() => {
    let timeoutId: number;

    function handleResize() {
      setIsResizing(true);

      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        setIsResizing(false);
      }, 100);
    }

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isResizing;
};
